import { useRef } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { FnrPopoverWithScroll } from "UI/FnrPopover2";
import { HoverChild } from "UI/HoverChildren";

export default function QuickControlButton({
  text,
  icon,
  children,
  onButtonClick,
  showPopover = false,
  attemptClosePopover,
  disabled = false,
  faded = false,
}) {
  const buttonRef = useRef();

  const buttonClicked = () => {
    if (showPopover) attemptClosePopover();
    else onButtonClick();
  };

  return (
    <>
      <OptionButton
        data-cy="PaymentMethod_EditPaymentMethodButton"
        ref={buttonRef}
        onClick={disabled ? null : buttonClicked}
        opacity={faded ? 0.6 : 1}
      >
        <HoverChild
          forceHover={showPopover}
          disabled={!showPopover && disabled}
        >
          <OptionButtonInside whileTap={{ scale: 0.9 }}>
            <OptionIcon className={icon} />
            {text}
          </OptionButtonInside>
        </HoverChild>
      </OptionButton>
      <FnrPopoverWithScroll
        buttonRef={buttonRef}
        show={showPopover}
        onShouldClose={attemptClosePopover}
        scrollingElClassname=".user_profile_right"
      >
        {children}
      </FnrPopoverWithScroll>
    </>
  );
}

const OptionButton = styled(motion.div)`
  position: relative;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 400;
  position: relative;
  z-index: 100;
  width: 25%;
  flex-grow: 0;
  flex-shrink: 0;
  opacity: ${(props) => props.opacity};
  .hasOtherOwner & {
    width: 50%;
    .width_360 & {
      width: fit-content;
    }
  }
  .editButtonOnly &,
  .singleButtonOnly & {
    width: 100% !important;
  }
  .width_320 & {
    font-size: 11px;
    width: fit-content;
  }
`;
const OptionButtonInside = styled(motion.div)`
  padding: 4px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  .width_320 & {
    padding: 4px 8px;
  }
  .width_320.card_type_amex & {
    padding: 4px 5px;
  }
`;
const OptionIcon = styled.div`
  display: block;
  margin-right: 5px;
`;
